import React, { useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { Placement } from 'react-bootstrap/types';
import '../../styles/PopOverlay.scss';

export interface Props {
  children: any;
  content: any;
  className?: string;
  placement?: Placement;
}

export const PopOverlay = ({ children, content, placement, className }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const popover = (
    <Popover id='popover-basic' as='div'>
      <Popover.Body>{content}</Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger='click'
      onToggle={setIsOpen}
      rootClose={true}
      rootCloseEvent={'click'}
      placement={placement ? placement : 'bottom'}
      overlay={popover}
    >
      {typeof children === 'function' ? (
        children(isOpen)
      ) : (
        <div className={`${className ? className : ''} ${isOpen ? 'popup-open' : ''}`}>{children}</div>
      )}
    </OverlayTrigger>
  );
};
